import { GlobalWorkerOptions } from "pdfjs-dist/legacy/build/pdf";
import { useEffect } from "react";

export function usePdfjsConfiguration(pdfWorkerSrc: string) {
  useEffect(() => {
    GlobalWorkerOptions.workerSrc = pdfWorkerSrc;
  }, [pdfWorkerSrc]);
}
